module.exports = __webpack_public_path__ + "img/1510233913.2134d62d.jpg";